import { notificationIcon } from '@/components/navbar/notificationIcons'
import { RetryingImage } from '@/components/ui'
import type { Notification } from '@/types'
import { formatRelativeTime } from '@/utils/format'

interface NotificationItemProps {
  notification: Notification
  onClick: (notification: Notification) => void
}

export function NotificationItem({ notification, onClick }: NotificationItemProps) {
  const icon = notificationIcon(notification.icon)
  const unread = !notification.read

  return (
    <button
      onClick={() => onClick(notification)}
      className={`w-full text-left p-3 hover:bg-hover transition-colors ${unread ? 'bg-blue-900/20' : ''}`}
    >
      <div className="flex gap-3">
        <RetryingImage
          src={notification.imageUrl}
          alt=""
          className="w-10 h-14 object-cover rounded"
          fallback={
            <div className={`w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold ${icon.style}`}>
              {icon.letter}
            </div>
          }
        />
        <div className="flex-1 min-w-0">
          <p className={`text-sm truncate ${unread ? 'text-primary font-medium' : 'text-secondary'}`}>
            {notification.title}
          </p>
          <p className="text-xs text-muted mt-0.5">{notification.body}</p>
          <p className="text-xs text-faint mt-1">{formatRelativeTime(notification.createdAt)}</p>
        </div>
        {unread && <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0 mt-1" />}
      </div>
    </button>
  )
}
